import React, { Component } from "react";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./NotificacionCarousel.css";
import CardCommunications from "../card-communications";
import { REACT_APP_CARUSEL_AUTOPLAY_SPEED_MS } from "../../services/url";

function NotificacionCarousel({ notifications} : any) {
  const settings = {
    dots: true,
    infinite: notifications.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: Number(REACT_APP_CARUSEL_AUTOPLAY_SPEED_MS),
    swipeToSlide: true,
    pauseOnHover: true,
  };
  
  return (
    <div className="slider-container">
      <Slider {...settings}>
        { notifications.map((notification :any) => 
          <CardCommunications key={notification.id}  notification={notification} origin="home"/>
        )}
      </Slider>
    </div>
  );
}

export default NotificacionCarousel;